import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgWalletLinkIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.635 2.117a3.889 3.889 0 0 0-5.521 0L6.89 5.335a3.894 3.894 0 0 0-1.09 3.404c.083.506.268 1.011.553 1.466.151.253.336.472.537.691l.621.624 1.141-1.146-.62-.624a2.105 2.105 0 0 1-.487-.741 2.34 2.34 0 0 1 .503-2.51l3.206-3.22a2.293 2.293 0 0 1 3.239 0c.89.894.89 2.343 0 3.253l-1.527 1.533c.234.64.335 1.331.302 2.005l2.383-2.392c1.51-1.534 1.493-4.028-.017-5.561Z"
      fill="#1652F0"
    />
    <path
      d="M11.271 7.745a3.13 3.13 0 0 0-.554-.69l-.62-.624-1.142 1.146.621.623c.218.22.386.489.487.758.335.826.167 1.82-.504 2.494l-3.205 3.219a2.293 2.293 0 0 1-3.24 0 2.316 2.316 0 0 1 0-3.252l1.528-1.534a4.815 4.815 0 0 1-.285-2.005l-2.383 2.393a3.927 3.927 0 0 0 0 5.544 3.909 3.909 0 0 0 5.538 0l3.205-3.219a3.958 3.958 0 0 0 1.091-3.404 4.211 4.211 0 0 0-.537-1.449Z"
      fill="#1652F0"
    />
  </svg>
);

export default SvgWalletLinkIcon;
